import { SelectOption } from '@/types/form.type.ts';

export enum CarBodyType {
    Sedan = 'sedan',
    Hatchback = 'hatchback',
    Crossover = 'crossover',
    Universal = 'universal',
    Coupe = 'coupe',
    Limousine = 'limousine',
}

export function getCarBodyTypeLabel(type: CarBodyType): string {
    switch (type) {
        case CarBodyType.Sedan:
            return 'Седан';
        case CarBodyType.Hatchback:
            return 'Хэтчбек';
        case CarBodyType.Crossover:
            return 'Кроссовер';
        case CarBodyType.Universal:
            return 'Универсал';
        case CarBodyType.Coupe:
            return 'Купе';
        case CarBodyType.Limousine:
            return 'Лимузин';
    }
}

export function getCarBodyTypeSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarBodyType).forEach((type: CarBodyType) => {
        options.push({
            label: getCarBodyTypeLabel(type),
            value: type,
        });
    });

    return options;
}
